<template>
    <div class="signup-page">
        <br/>
        <br/>
        <b-container>
            <b-row align-h="center">
                <h1>Signup</h1>
            </b-row>
            <b-row align-h="center">
                <b-col cols="6">
                    <b-form-group id="login-usertype-group" label-for="login-usertype-select" label="User Type:">
                        <b-form-select id="login-usertype-select" v-model="form.selected" :options="form.users" @input.native="userTypeChange"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
        <patient-signup v-if="form.selected === 0"></patient-signup>
        <provider-signup v-else-if="form.selected === 1"></provider-signup>
    </div>
</template>
<script>
    import PatientSignup  from '../patient/patient-signup';
    import ProviderSignup from '../provider/provider-signup';

    export default
    {
        name: 'Signup',
        components: {
            PatientSignup,
            ProviderSignup
        },
        data ()
        {
            return {
                form: {
                    selected: null,
                    users: [
                        { value: null, text: "Select one" },
                        { value: 0, text: "Patient" },
                        { value: 1, text: "Provider" }
                    ]
                }
            }
        },
        methods: {
            userTypeChange:
            function ( event )
            {
                var selected = this.$data.form.selected;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/account/signup.vue